import { useAuth } from './component/authentication/AuthContext';
import AccessDeniedPage from "./component/AccessDeniedPage";

const ProtectedRoute = ({ allowedRoles, children }) => {
    const { userGroups } = useAuth();
    if (Array.isArray(userGroups) && userGroups.some(role => allowedRoles.includes(role))) {
        return children;
    } else {
        return <AccessDeniedPage/>;
    }
};

export default ProtectedRoute;